/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Device, PlaybackOption } from '@repo/types'
import startCase from 'lodash.startcase'

import { getPlaylistDetails } from './getPlaylistDetails'
import { formatTimestamp } from './utils'
import { GameStore } from '../store/game/GameStore'

// Keep in sync with API

function getMusicGameDetails(game: GameStore) {
  if (game.gameData.type !== 'music') return

  return {
    'Current Song Number': game.gameData.currentItemIndex,
    'Hide Artist': game.gameData.disableArtist,
    ...getPlaylistDetails(game.gameData.sourcePlaylistMeta)
  }
}

function getDeviceDetails(device?: Device) {
  if (!device) return

  return {
    'Playback Device ID': device.id,
    'Playback Device Name': device.name,
    'Playback Device Type': startCase(device.type),
    'Playback Player Type': device.isExternal ? 'External' : 'Internal'
  }
}

function getIntegrationDetails(game: GameStore) {
  if (
    game.gameData.type !== 'music' ||
    game.gameData.playbackSource === PlaybackOption.NONE ||
    !game.integration
  )
    return

  const { gameData, integration } = game

  return {
    Integration: startCase(integration.id),
    'Playback Source': gameData.playbackSource ? startCase(gameData.playbackSource) : undefined,
    ...getDeviceDetails(integration.devices.activeDevice)
  }
}

function getNumbersGameDetails(game: GameStore) {
  if (game.gameData.type !== 'numbers') return

  return {
    'Current Number': game.gameData.currentItemIndex
  }
}

export function getGameDetails(game: GameStore) {
  return {
    'Active Players': game.activePlayers.length,
    'Bingo Count': game.gameData.bingoCount,
    'Bingo Target': startCase(game.gameData.currentTarget.replace(/_/g, ' ')),
    'Called Bingos Count (Current)': game.calledBingosList.length,
    'Current Column Letter': game.currentColumnName,
    'Disable Bingo Verification': game.gameData.disableSystemBingoVerification,
    'Game Branding Call To Action Button Label':
      game.gameData.userSettings?.branding?.callToAction?.button.label,
    'Game Branding Call To Action Button URL':
      game.gameData.userSettings?.branding?.callToAction?.button.url,
    'Game Branding Image Filename': game.gameData.userSettings?.branding?.image?.filename,
    'Game Branding Image URL': game.gameData.userSettings?.branding?.image?.url,
    'Game Code': game.gameData.gameCode,
    'Game Created': formatTimestamp(game.gameData.timestamp),
    'Game ID': game.gameId,
    'Game Started': formatTimestamp(game.gameData.gameStarted),
    'Game Status': startCase(game.gameData.gameStatus.replace(/_/g, ' ')),
    'Game Type': startCase(game.gameData.type),
    'Highlight Current Column': game.gameData.highlightColumns,
    'Host Email': game.gameData.hostEmail,
    'Host ID': game.gameData.hostId,
    'Last Activity': formatTimestamp(game.gameData.lastActivity),
    'Player Count (Current)': game.gameData.playerCount,
    'Player Count (Total)': game.gameData.playerCountFinal,
    'Players in Lobby': game.playersInLobby.length,
    'Players Left Game': game.playersLeftGame.length,
    'Remaining Player Seats': game.remainingPlayerSlots,
    'Removed Players': game.removedPlayers.length,
    'Request Winner Contact Details': game.gameData.requestContactDetails,
    'Scoreboard Enabled': game.gameData.enableScoreboard,
    'Venue ID': game.gameData.venueId,
    'Venue Name': game.gameData.venueName,
    ...getMusicGameDetails(game),
    ...getNumbersGameDetails(game),
    ...getIntegrationDetails(game)
  }
}
